import React, { Component } from "react";
import MyPATTabs from "../../common/MyPATTabs";
import MyPATTab from "../../common/MyPATTab";
import { WithStyles, Grid, withStyles, Tabs, Tab } from "@material-ui/core";
import { courseLandingPageStyles } from "../styles";
import {
  AddCourseMileStone,
  NoContent,
  ViewPhase,
  //   CreateCourseType,
  CreateCoursePlan,
} from "../components/index";
import { HeadingComponent, CoursePlan, CombinedPhases } from "../components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { contentManagementAction } from "../reducers/contentMangementData";
import { AddMilestone } from "../components/coursePlan/addMilestone";
import _ from "lodash";
import CoursePlanTree from "../components/coursePlan/courseListing/CoursePlanTree";
import AdvancedSettings from "../components/AdvancedSettings/AdvancedSettings";
import courseManagementServices from "../service/courseManagementServices";
import { createCoursePlanStatesAction } from "../reducers/createCoursePlanReducer";
import { contentManagementService } from "../service";
import TestSeriesCoursePlan from "../components/TestSeriesCoursePlan";
import {
  CourseBasicDetails,
  TestSeriesCoursePlan as testSeriesCoursePlan,
  Package,
  TestDetail,
} from "../types/interfaces/CourseBasicDetails";
import { coursePlan } from "../mockData/packageById";
import TabPanel from "../../userManagement/common/TabPanel";
import { CourseTypes } from "../types/enums/CourseTypes";
import {
  buildSKUString,
  getCreateCourseDefaultFormData,
  getDeafultTestDetail,
  getGeneralSetting,
  getRequestId,
} from "../helpers/helpers";
import TestSeriesBasicInfo from "../components/TestSeriesBasicInfo";
import { dateService } from "../../common";
import { courseManagementActions } from "../reducers/courseManagementReducer";
import {
  setActiveTab,
  saveAdvancedSetting,
  publishCourse,
  checkAdvancedSettingsMandatoryFields,
  approveAndPublishCourse,
  rejectCourse,
} from "../actions/courseManagementActions";
import { contentManagementReducer } from "../reducers";
import { showMsg } from "../../course/actions/loaderAlert";
import { BasicInfo } from "../types/interfaces/BasicInfo";
import {
  storeGeneralSettings,
  storeFAQ,
  storeSEO,
  saveAdvancedSettings,
  getCourseDetails,
} from "../actions/courseManagementActions";
import { ProcessingStatus } from "../types/enums/ProcessingStatus";
import ACLService from "../../acl/services/aclService";
interface TestSeriesCourseContainerProps
  extends WithStyles<typeof courseLandingPageStyles> {
  classes: any;
  setPackageById: Function;
  setPackages: Function;
  getPackageByIdData: any;
  getPackages: any;
  match: any;
  treeData: any;
  selectedCourseData: any[];
  coursePlanResponse: any;
  setCoursePlanResponse: Function;
  setSelectedCourseData: Function;
  history: any;
  setPackageId: Function;
  setSelectedGoalsForTestSeries: Function;
  saveAdvancedSetting: Function;
  publishCourse: Function;
  setTestCount: Function;
  testCount: number;
  setMinStartDate: Function;
  setTestSeriesBasicInfo: Function;
  basicDetail: CourseBasicDetails;
  advancedSettingsValid: boolean;
  isCoursePublished: boolean;
  showMsg: Function;
  checkAdvancedSettingsMandatoryFields: Function;
  setPackageData: Function;
  storeGeneralSettings: Function;
  storeFAQ: Function;
  storeSEO: Function;
  setSavedSuccessfully: (data: { key: string, value: boolean }) => void;
  setPollingStatus: Function,
  approveAndPublishCourse: Function,
  rejectCourse: Function

}
interface TestSeriesCourseContainerState {
  activeComponent: string;
  coursePlanId: string;
  packageId: string;
  packageData: Package|BasicInfo;
  coursePlan: testSeriesCoursePlan|any;
  activeTab: any;
  activePublish: boolean;
  isPreviewScreen: boolean;
  loading: boolean;
  activeSave: boolean;
  processingStatus: ProcessingStatus;
  hasDuplicateRight:boolean,
  disableEdit:boolean
}

class TestSeriesCourseContainer extends Component<
  TestSeriesCourseContainerProps,
  TestSeriesCourseContainerState
> {
  packageId: any;
  path: string;
  constructor(props: TestSeriesCourseContainerProps) {
    super(props);
    this.packageId = _.get(this.props, "match.params.id");
    this.path = _.get(this.props, "match.path");
    this.props.setPackageId(this.packageId);
    this.state = {
      activeComponent: "CoursePlan",
      coursePlanId: "",
      packageId: this.packageId,
      packageData: this.generateDefaultPackage(),
      activeTab: 0,
      activePublish: false,
      isPreviewScreen:
        this.path === "/course-Management/testSeries/:id/preview",
      loading: false,
      activeSave: false,
      coursePlan: {},
      processingStatus: ProcessingStatus.DRAFT,
      hasDuplicateRight:false,
      disableEdit:false
    };
  }
  componentDidMount = () => {
    const userData = ACLService.getUserDetailsFromStorage();
    const clientId = userData.authenticatedUser.aclMetaData.clientId;
    const { packageId } = this.state;
    courseManagementServices.getPackageById(packageId).then((res) => {
      const packageData: BasicInfo = _.get(res, "responseObject.packageData");
      const hasDuplicateRight=ACLService.checkModulePermission("course","create");
      const disableEditCTA= clientId!="5b5702e095cbc921944632a9"&& clientId!=packageData.aclMetaData.clientId;
     
      this.setState({hasDuplicateRight,disableEdit:disableEditCTA});
      if (
        packageData.status === "PUBLISHED" &&
        this.path === "/course-Management/testSeries/:id"
      ) {
        this.props.history.push(
          `/course-Management/testSeries/${packageId}/preview`
        );
      }
      const coursePlanId = _.get(packageData, "coursePlanId");

      if(packageData.status === "PUBLISHED" && coursePlanId) {
        courseManagementServices.getPublishProcessStatus(coursePlanId).then((res: any) => {
          const status: ProcessingStatus = _.get(res, 'publishProcess.status', ProcessingStatus.DRAFT);
          this.setState({
            processingStatus: status
          })
        })
      }

      this.setState({ packageData: packageData },()=>{
        if (coursePlanId) {
          this.getCoursePlanById(coursePlanId);
        } else {
          const coursePlan= this.generateDefaultCoursePlan();
          this.setState({coursePlan},()=>{
            this.props.setTestCount(
              JSON.parse(localStorage.getItem("testCount") || "1")
            );
          })
        }
        // const generalSettings = getGeneralSetting(packageData);
        // const faq = packageData.FAQ;
        // const seo = packageData.metatags;
        const basicDetails = this.setPackageDetails(packageData);
        // this.props.storeGeneralSettings(generalSettings);
        // this.props.storeFAQ(faq);
        // this.props.storeSEO(seo);
        this.props.setTestSeriesBasicInfo(basicDetails);
        this.props.setSelectedGoalsForTestSeries({
          selectedGoalsForTestSeries: JSON.parse(
            JSON.stringify(packageData.courseDetails)
          ),
        });
        // this.props.checkAdvancedSettingsMandatoryFields();
      });  
      this.props.setPackageId({ packageData });
    });
  };
  componentDidUpdate = (
    prevProps: TestSeriesCourseContainerProps,
    prevState: TestSeriesCourseContainerState
  ) => {
    if (
      prevState.coursePlan !== this.state.coursePlan ||
      prevProps.basicDetail !== this.props.basicDetail ||
      prevProps.advancedSettingsValid !== this.props.advancedSettingsValid
    ) {
      this.setSavePublishActive();
    }
    if (prevProps.testCount !== this.props.testCount) {
      this.addMoreTestDetails();
      this.setBasicTestDetail(this.props.testCount);
    }
    if (
      prevProps.isCoursePublished !== this.props.isCoursePublished &&
      this.props.isCoursePublished
    ) {
      // setTimeout(()=>{this.props.history.push(`/course-Management`)},2000);
      // this.props.history.push(`/course-Management/testSeries/${this.packageId}/preview`);
      this.props.history.push(`/course-Management`);
    }
  };
  setBasicTestDetail = (testCount: number) => {
    const { basicDetail } = this.props;
    const newBasicDetail = { ...basicDetail };
    newBasicDetail.testCount = testCount;
    this.props.setTestSeriesBasicInfo(newBasicDetail);
  };
  setSavePublishActive = () => {
    const t1 = this.props.advancedSettingsValid;
    const t2 = this.validBasicInfo();
    const t3 = this.validCoursePlan();
    
    console.log({ t1, t2, t3 });
    if (t2) {
      const coursePlanId = _.get(this.state.packageData, "coursePlanId");
      console.log({ coursePlanId });
      this.setState((prevState) => {
        if (coursePlanId && t1 && t3) {
          console.log(coursePlanId && t1 );
          return { ...prevState, activePublish: true, activeSave: true };
        } else return { ...prevState, activeSave: true,activePublish: false };
      });
      
    } else {
      this.setState({ activeSave: false, activePublish: false });
      
    }
  };

  isTestAMainTest = (test: any) => {
    const { type } = test;
    const mainTestTypes = ['part', 'full', 'combined'];
    
    if(mainTestTypes.includes(type)) { return true } else { return false; }
  }

  validCoursePlan = () => {
    const { coursePlan } = this.state;
    const {
      endDate,
      packageId,
      startDate,
      testSeries,
      totalTests,
    } = coursePlan;
    const zero24='000000000000000000000000';
    // if (
    //   _.isEmpty(endDate) ||
    //   _.isEmpty(startDate) ||
    //   _.isEmpty(testSeries) ||
    //   totalTests !== testSeries.length
    // ) {
    //   return false;
    // }
    console.log(testSeries, _.isEmpty(testSeries))
    if(testSeries && _.isEmpty(testSeries)){
      
      return false;
    }
    if(testSeries) {
      const optionalKeys=["revisionTime","scheduleID","endDate","testId'"];
      for (let indx = 0; indx < testSeries.length; indx++) {
        for (const [innerkey, innervalue] of Object.entries(testSeries[indx])) {
          const isTestAMainTest = this.isTestAMainTest(testSeries[indx])
          
          // const minStartDate=_.get(this.props,"basicDetail.startDate.value");
          // const minEndDate=_.get(this.props,"basicDetail.endDate.value");
          // if(!(startDate>=minStartDate&&startDate<=minEndDate)){
          //   return true
          // }
         
          // revisionTime
          if (optionalKeys.includes(innerkey)) continue;
          if(isTestAMainTest){
            
            if(innerkey === "maxAttempts") continue;
          }
          // if(&&innervalue===zero24){
          //    return false;
          // }  
          else if (!_.isInteger(innervalue) && _.isEmpty(innervalue)) {
            
            return false;
          }
        }
      }
    }
    return true;
  };
  validBasicInfo = () => {
    const { basicDetail } = this.props;
    const {
      name,
      sku,
      courseDetails,
      startDate,
      endDate,
      packageAdmins,
    } = basicDetail;
    const tempObject = {
      name,
      sku,
      courseDetails,
      startDate,
      endDate,
      packageAdmins,
    };

    const testCount: any = _.get(
      basicDetail,
      "testCount",
      this.props.testCount
    );
    console.log(testCount)
      
    if (testCount === "" || testCount < this.props.testCount) return false;
    for (const [key, value] of Object.entries(tempObject)) {
      if (key === "sku" && (value.SKUText === "" || value.SKUNumber === ""))
        return false;
      else if (_.isEmpty(value)) {
        
        return false;
      }
    }
    return true;
  };
  handleSaveCoursePlan = async (forPublish: boolean, packageChangeRequestId?: string) => {
    try {
    this.props.setSavedSuccessfully({ key: 'coursePlan', value: false })
    const { coursePlan, packageData } = this.state;
    const { basicDetail } = this.props;
    const firstCourseId = _.get(packageData, "courseDetails[0].courseId", "");
    const newCoursePlan={...coursePlan};
    const { testSeries } = newCoursePlan;
    newCoursePlan.totalTests = testSeries.length;
    newCoursePlan.startDate = basicDetail.startDate.value;
    newCoursePlan.endDate = basicDetail.endDate.value;
    // coursePlan.testSeries.forEach((testDetail:any) => {
      //   if (testDetail.courseId === "") testDetail.courseId = firstCourseId;
      // });
    newCoursePlan.packageChangeRequestId = packageChangeRequestId;

      if ( packageData.coursePlanId) {
        if (forPublish) {
          newCoursePlan.status = "published";
        }
        this.setState({ coursePlan:newCoursePlan });
        const res =  await courseManagementServices.updateCousePlanApiById(newCoursePlan);
        if(!forPublish && res.statusCode !== 422) {
          newCoursePlan.updatedAt=_.get(res,"responseObject.coursePlan.updatedAt",newCoursePlan.updatedAt);
          this.setState({ coursePlan:newCoursePlan });
          this.props.setSavedSuccessfully({ key: 'coursePlan', value: true })
        }
        return res;
      } else {
        const res = await courseManagementServices.createCoursePlan(newCoursePlan);
        if (res.statusCode === 200) {
          const id = _.get(res, "responseObject.coursePlan._id", "");
          newCoursePlan._id = id;
          newCoursePlan.coursePlanId = id;
          packageData.coursePlanId=id;
        }
        this.setState({ coursePlan:newCoursePlan,packageData });
        if(!forPublish && res.statusCode !== 422) {
          this.props.setSavedSuccessfully({ key: 'coursePlan', value: true })
        }
        return res;
      }
    } catch (error) {
      console.log(error)
    }
  };
  handleSave = async (forPublish: boolean = false) => {
    const { activeTab } = this.state;
    let isSuccess = true
    this.props.setPollingStatus(true);
    const res = await this.handleSaveBasicDetail(forPublish);
    if (res.statusCode !== 200) {
      isSuccess = false
    }
    const packageChangeRequestId = res.responseObject && res.responseObject.packageChangeRequestId;
    const advanceResp = await this.props.saveAdvancedSetting({ packageId: this.packageId, packageChangeRequestId });
    const courseResponse = await this.handleSaveCoursePlan(forPublish, packageChangeRequestId);
    if (courseResponse.statusCode !== 200) {
      isSuccess = false
    }
    if(!(forPublish&&isSuccess)){
      this.props.setPollingStatus(false);
    }
    return { isSuccess, packageChangeRequestId };
  };
  handleSaveBasicDetail = async (forPublish: boolean) => {
    try {
    this.props.setSavedSuccessfully({ key: 'basicInfo', value: false })
    const { packageData } = this.state;
    const { basicDetail } = this.props;
    const newFormData = { ...basicDetail };
    console.log(newFormData)
    newFormData.targetYears = [newFormData.sku.SKUYear];
    newFormData.courseDetails = packageData.courseDetails;
    newFormData.startDate = newFormData.startDate.value;
    newFormData.expiryDate = newFormData.endDate.value;
    newFormData.sku = buildSKUString(newFormData.sku);
    const payload = { packageId: this.packageId, data: newFormData };
    
    // this.addMoreTestDetails();
    
    const res = await courseManagementServices.updatePackageBasicDetailsById(
      payload
    );
    if(!forPublish && res.statusCode !== 422) {
      this.props.setSavedSuccessfully({ key: 'basicInfo', value: true })
    }
    return res;
    } catch (error) {
      console.log(error)
    }
  };
  addMoreTestDetails = () => {
    const { testCount } = this.props;
    const { coursePlan } = this.state;
    const newCoursePlan = { ...coursePlan };
    const startIndx = newCoursePlan.testSeries.length;
    const requiredTestDetails = testCount - startIndx;
    let newTestSeries = [...newCoursePlan.testSeries];
    let combinedtestSeries = [];
    if (requiredTestDetails < 0) {
      combinedtestSeries = newTestSeries.splice(0, testCount);
    } else {
      const testDetails = this.getNDefaultTestDetails(
        requiredTestDetails,
        startIndx
      );
      combinedtestSeries.push(...newTestSeries, ...testDetails);
    }
    newCoursePlan.testSeries = combinedtestSeries;
    newCoursePlan.totalTests=combinedtestSeries.length;
    this.setState({ coursePlan: newCoursePlan });
  };
  getCoursePlanById = (id: string) => {
    courseManagementServices.getCousePlanApiById(id).then(({ coursePlan }) => {
      if (!_.isEmpty(coursePlan)) {
        const testSeries=_.get(coursePlan,"testSeries",[]);
        const testCount = _.get(coursePlan, "testSeries.length");
        // if(this.state.isPreviewScreen){
           this.sortTestSeries(testSeries)
        // }
        coursePlan.coursePlanId = id;
        this.setState({ coursePlan, loading: true },()=>{
          this.props.setTestCount(testCount);
        });
      }
    });
  };

  sortTestSeries(testSeries:TestDetail[]){  
     testSeries.sort((a,b)=>{    
        let aScheduleID=parseInt(a.scheduleID);
        let bScheduleID=parseInt(b.scheduleID);
      
         if((aScheduleID&&bScheduleID)||((_.isEmpty(aScheduleID)&&_.isEmpty(bScheduleID)))){  
          let d1:any=new Date(a.startDate);
          let d2:any=new Date(b.startDate);
           if(d1==d2){
               return aScheduleID-bScheduleID;
          } 
         return d1-d2; 
         } 
       return aScheduleID?-1:1;  
     });
  }
  setPackageDetails = (packageData: BasicInfo) => {
    //   packageAdmins
    const formData: CourseBasicDetails = getCreateCourseDefaultFormData();
    const { name, sku, startDate, expiryDate, courseDetails, duration } = packageData;
    const packageAdmins = _.get(packageData, "packageAdmins", []);
    const skuDetails = sku.split("-");
    formData.name = name;
    formData.courseDetails = courseDetails;
    formData.startDate = {
      label: dateService.dateOnly(startDate),
      value: startDate,
    };
    formData.endDate = {
      label: dateService.dateOnly(expiryDate),
      value: expiryDate,
    };
    formData.duration = duration;
    formData.expiryDate = expiryDate;
    formData.type = CourseTypes.testSeries;
    formData.sku = {
      SKUText: skuDetails[0],
      SKUNumber: +skuDetails[1],
      SKUYear: +skuDetails[2],
    };
    formData.packageAdmins = packageAdmins;
    formData.testCount = this.props.testCount;
    formData.subType = packageData.subType;
    return formData;
  };
  generateDefaultCoursePlan = () => {
    let testCount: any = localStorage.getItem("testCount");
    if (testCount) {
      testCount = JSON.parse(testCount);
    } else testCount = 1;
    const{packageData}=this.state;
    const{startDate,expiryDate}=packageData;
    const coursePlan: testSeriesCoursePlan = {
      _id: "",
      endDate: expiryDate,
      packageId: this.packageId,
      startDate: startDate,
      totalTests: testCount,
      type: CourseTypes.testSeries,
      testSeries: [],
      weekFormat: "mondayToSunday",
      status: "draft",
    };
    const testSeries = this.getNDefaultTestDetails(testCount, 0);
    coursePlan.testSeries = testSeries;
    return coursePlan;
  };
  getNDefaultTestDetails = (n: number, startIndx: number) => {
    const testSeries = [];
    const {packageData} =this.state;
    const{startDate}=packageData;
    const firstCourseId = _.get(packageData, "courseDetails[0].courseId", "");
    for (let indx = 0; indx < n; indx++) {
      const testDetail: TestDetail = getDeafultTestDetail();
      testDetail.name = `Test-${startIndx + indx + 1}`;
      testDetail.courseId=firstCourseId;
      // testDetail.startDate=startDate;
      testSeries.push(testDetail);
    }
    return testSeries;
  };
  generateDefaultPackage = () => {
    const packageData: Package = {
      _id: "",
      courseDetails: [],
      expiryDate: "",
      name: "",
      sku: "",
      startDate: "",
      status: "",
      type: CourseTypes.testSeries,
      versions: [],
    };
    return packageData;
  };
  handlePublish = async () => {
    const requestId = getRequestId();
    if (requestId) {
      this.props.approveAndPublishCourse({ requestId });
      return;
    }

    const { isSuccess: isSuccessful, packageChangeRequestId } = await this.handleSave(true);
    if (isSuccessful) {
      this.props.publishCourse({ id: this.packageId ,packageChangeRequestId});
    }
  };
  handleDuplicate=()=>{
    const { params: { id = ''} } = this.props.match;
    try{
      courseManagementServices.createDuplicatePackage({packageId:id}).then((res:any)=>{
        if(res.statusCode===200){
            //  const packageID=_.get(res,"responseObject.packageId","");
            this.props.showMsg(res.responseMessage,'success'); 
             setTimeout(()=>{
               this.props.history.replace(`/course-Management/`);
              },100);
        }else{
          this.props.showMsg(res.responseMessage,'error'); 
        }
      });
    }catch(err){
      console.log({err});
    } 
   }

  renderHeadingComponent = () => {
    const { isPreviewScreen, packageData, activePublish, processingStatus,coursePlan } = this.state;
    const { name, status, expiryDate } = packageData;
    const isCourseExpired = new Date() > new Date(expiryDate);
    const updatedStatus = isCourseExpired ? 'past' : status
    const isUpdateLocked = coursePlan.isUpdateLocked || !coursePlan.isEditable;
    const disableEdit = processingStatus === ProcessingStatus.QUEUED || processingStatus === ProcessingStatus.STARTED || isUpdateLocked;
    
    return (
      <HeadingComponent
        name={name}
        status={updatedStatus}
        handleSave={this.handleSave}
        handlePublish={this.handlePublish}
        canPublishCourse={activePublish || status.toLowerCase() === "published"}
        hideSave={isPreviewScreen || status.toLowerCase() === "published"}
        hidePublish={isPreviewScreen}
        showEdit={isPreviewScreen}
        disableEdit={disableEdit||this.state.disableEdit}
        handleEdit={this.handleEdit}
        coursePlanDone={true}
        basicInfoDone={true}
        advancedSettingsDone={true}
        isSaveDisable={!this.state.activeSave}
        hasDuplicateRight={this.state.hasDuplicateRight}
        duplicate={this.handleDuplicate}
        coursePlanData={coursePlan}
        hideDuplicate={true}
      />
    );
  };

  handleTabSwitch = (event: any, newValue: any) => {
    this.setState({ activeTab: newValue });
  };

  a11yProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  handleChange = (coursePlan: testSeriesCoursePlan) => {
    this.props.setTestCount(coursePlan.testSeries.length);
    // const minDate=this.getMinDate(coursePlan.testSeries);
    // this.props.setMinStartDate(minDate)
    console.log({coursePlan});
    this.setState({ coursePlan });
  };
  // getMinDate=(testSeries:TestDetail [])=>{
  //     const dates:any []=[];
  //     testSeries.forEach((testDetail)=>{
  //         if(!_.isEmpty(testDetail.startDate))
  //              dates.push(new Date(testDetail.startDate));
  //     })
  //     return dates.length>0? new Date(Math.min.apply(null,dates)):'';
  // }
  renderTabs = () => {
    const { classes } = this.props;
    const { activeTab } = this.state;

    return (
      <Grid className={classes.tabContainer}>
        {/* <div className={classes.root}> */}
        {/* <AppBar position="static"> */}
        <Tabs
          classes={{ indicator: classes.indicatorColorStyle }}
          value={activeTab}
          onChange={this.handleTabSwitch}
          aria-label="simple tabs example"
        >
          <Tab
            label="Course Plan"
            {...this.a11yProps(0)}
            className={
              this.state.activeTab === 0
                ? classes.active_tab
                : classes.default_tabStyle
            }
          />
          <Tab
            label="Basic Info"
            {...this.a11yProps(1)}
            className={
              this.state.activeTab === 1
                ? classes.active_tab
                : classes.default_tabStyle
            }
          />
          <Tab
            label="Advance Setting"
            {...this.a11yProps(2)}
            className={
              this.state.activeTab === 2
                ? classes.active_tab
                : classes.default_tabStyle
            }
          />
        </Tabs>
        {/* </AppBar> */}
        <TabPanel value={activeTab} index={0} >
          <Grid className={classes.testSeriesContainer}>
            {this.renderCoursePlanTabComponents()}
            {/* <CreateCoursePlan classes={classes} match={this.props.match} /> */}
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={1} >
          <Grid className={classes.testSeriesContainer}>
            {this.renderBasicInfo()}
          </Grid>
        </TabPanel>
        <TabPanel value={activeTab} index={2} unmountOnExit={false} >
          <Grid className={classes.tabArea}>
            {/* add yourcomponent here */}
            <AdvancedSettings 
               isPreview={this.state.isPreviewScreen} 
            />
            {/* <CreateCourseType/> */}
            {/* <CombinedPhases /> */}
          </Grid>
        </TabPanel>
        {/* </div> */}
      </Grid>
    );
  };
  handleEdit = () => {
    const{coursePlan}=this.state;
    const isUpdateLocked=_.get(coursePlan,'isUpdateLocked',false);
    if(isUpdateLocked){
      return ;
    }
    this.props.history.push(
      `/course-Management/testSeries/edit/published/${this.packageId}`
    );
  };
  renderCoursePlanTabComponents = () => {
    const { classes } = this.props;
    const { packageData, coursePlan, isPreviewScreen } = { ...this.state };

    return (
      <TestSeriesCoursePlan
        packageData={packageData}
        requestCoursePlan={coursePlan}
        transferToParent={this.handleChange}
        isPreviewScreen={isPreviewScreen}
      />
    );
  };
  renderBasicInfo = () => {
    const { classes } = this.props;
    const { packageData, coursePlan, isPreviewScreen } = { ...this.state };
    return (
      <TestSeriesBasicInfo
        packageData={packageData}
        coursePlan={coursePlan}
        isPreviewScreen={isPreviewScreen}
      />
    );
  };

  render = () => {
    return (
      <>
        {this.renderHeadingComponent()}
        {this.renderTabs()}
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    testCount:
      state.courseMangementData.courseManagementReducer.testSeries.testCount,
    basicDetail:
      state.courseMangementData.courseManagementReducer.testSeries.basicDetail,
    // advancedSettingsValid:
    //   state.courseMangementData.contentManagementData.advancedSettingsValid,
    isCoursePublished:
      state.courseMangementData.contentManagementData.isCoursePublished,
      advancedSettingsValid: state.courseMangementData.contentManagementData.advancedSettingMandatoryFlag,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPackageId: courseManagementActions.setPackageId,
      setSelectedGoalsForTestSeries:
        contentManagementAction.setSelectedGoalsForTestSeries,
      setTestCount: courseManagementActions.setTestCount,
      setMinStartDate: courseManagementActions.setMinStartDate,
      // setPackages: contentManagementAction.setPackages,
      // setSelectedCourseData: contentManagementAction.setSelectedCourseData,
      // setCoursePlanResponse: createCoursePlanStatesAction.setCoursePlanResponse
      saveAdvancedSetting: saveAdvancedSetting,
      publishCourse: publishCourse,
      setTestSeriesBasicInfo: courseManagementActions.setTestSeriesBasicInfo,
      showMsg: showMsg,
      checkAdvancedSettingsMandatoryFields: checkAdvancedSettingsMandatoryFields,
      setPackageData: contentManagementAction.setPackageData,
      storeGeneralSettings: storeGeneralSettings,
      storeFAQ: storeFAQ,
      storeSEO: storeSEO,
      setSavedSuccessfully: courseManagementActions.setSavedSuccessfully,
      setPollingStatus:courseManagementActions.setPollingStatus,
      approveAndPublishCourse,
      rejectCourse,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseLandingPageStyles)(TestSeriesCourseContainer));
